import { render, staticRenderFns } from "./BorderAnimation.vue?vue&type=template&id=3dd2adc3&scoped=true&"
import script from "./BorderAnimation.vue?vue&type=script&lang=js&"
export * from "./BorderAnimation.vue?vue&type=script&lang=js&"
import style0 from "./BorderAnimation.vue?vue&type=style&index=0&id=3dd2adc3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd2adc3",
  null
  
)

export default component.exports